import { DatabaseFileLabel } from "../types";

export interface FileLabelStyling {
  iconColor: string;
  bgColor: string;
  borderColor: string;
  textColor: string;
}

export const getFileLabelStyling = (label: DatabaseFileLabel): FileLabelStyling => {
  switch (label.resourceType) {
    case 'building':
      return {
        iconColor: 'text-blue-600',
        bgColor: 'hover:bg-blue-50',
        borderColor: 'border-blue-200',
        textColor: 'text-blue-800'
      };
    case 'unit':
      return {
        iconColor: 'text-green-600',
        bgColor: 'hover:bg-green-50',
        borderColor: 'border-green-200',
        textColor: 'text-green-800'
      };
    default:
      return {
        iconColor: 'text-moss-primary',
        bgColor: 'hover:bg-moss-primary/10',
        borderColor: 'border-neutral-primary/20',
        textColor: 'text-neutral-primary'
      };
  }
};

export const getResourceTypeLabel = (resourceType: string | null): string => {
  switch (resourceType) {
    case 'building':
      return 'Gebouw';
    case 'unit':
      return 'Unit';
    default:
      return resourceType || '';
  }
};